import { useCallback, useEffect, useState } from 'react';
import { readDemoCleanParam } from './demoNoticeRule';

const DISMISSED_KEY = 'm24DemoNoticeDismissed';
const CLEAN_KEY = 'm24DemoClean';

function readFlag(key: string): boolean {
  try {
    return sessionStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}

function writeFlag(key: string, value: boolean): void {
  try {
    if (value) {
      sessionStorage.setItem(key, '1');
    } else {
      sessionStorage.removeItem(key);
    }
  } catch {
    /* Private browsing: the React state still covers this page load. */
  }
}

export interface DemoNoticeSession {
  isDismissed: boolean;
  isCleanForSession: boolean;
  dismiss: () => void;
}

/**
 * The per-session state of the demo notice (design: music24-demo-artist a2/a6): the close button,
 * and `?demo-clean=` remembered for the session, so a screen recording can click through the app
 * after one URL with `?demo-clean=1`. `?demo-clean=0` clears it.
 */
export function useDemoNoticeSession(search: string): DemoNoticeSession {
  const [isDismissed, setDismissed] = useState(() => readFlag(DISMISSED_KEY));
  const [isCleanForSession, setCleanForSession] = useState(() => readFlag(CLEAN_KEY));

  useEffect(() => {
    const fromUrl = readDemoCleanParam(search);
    if (fromUrl === null) {
      return;
    }
    writeFlag(CLEAN_KEY, fromUrl);
    setCleanForSession(fromUrl);
  }, [search]);

  const dismiss = useCallback(() => {
    writeFlag(DISMISSED_KEY, true);
    setDismissed(true);
  }, []);

  return { isDismissed, isCleanForSession, dismiss };
}
